export const GET_TEST_CASE_LOADING = "GET_TEST_CASE_LOADING";
export const GET_TEST_CASE_SUCCESS = "GET_TEST_CASE_SUCCESS";
export const GET_TEST_CASE_FAILED = "GET_TEST_CASE_FAILED";
export const LINK_TEST_CASE_LOADING = "LINK_TEST_CASE_LOADING";
export const LINK_TEST_CASE_SUCCESS = "LINK_TEST_CASE_SUCCESS";
export const LINK_TEST_CASE_FAILED = "LINK_TEST_CASE_FAILED";
export const TOGGLE_TEST_LINKING = "TOGGLE_TEST_LINKING";
export const UNLINK_TEST_CASE_LOADING = "UNLINK_TEST_CASE_LOADING";
export const UNLINK_TEST_CASE_SUCCESS = "UNLINK_TEST_CASE_SUCCESS";
export const UNLINK_TEST_CASE_FAILED = "UNLINK_TEST_CASE_FAILED";
export const GLOBAL_SEARCH_LOADING = "GLOBAL_SEARCH_LOADING";
export const GLOBAL_SEARCH_SUCCESS = "GLOBAL_SEARCH_SUCCESS";
export const GLOBAL_SEARCH_FAILED = "GLOBAL_SEARCH_FAILED";
export const CLEAR_GLOBAL_SEARCH = "CLEAR_GLOBAL_SEARCH";
export const GET_ALL_USERS_FAILED = "GET_ALL_USERS_FAILED";
export const GET_ALL_USERS_LOADING = "GET_ALL_USERS_LOADING";
export const GET_ALL_USERS_SUCCESS = "GET_ALL_USERS_SUCCESS";
export const CREATE_TEST_CASE_FAILED = "CREATE_TEST_CASE_FAILED";
export const CREATE_TEST_CASE_LOADING = "CREATE_TEST_CASE_LOADING";
export const CREATE_TEST_CASE_SUCCESS = "CREATE_TEST_CASE_SUCCESS";
